<h6 class="px-20 pt-20">{{ data.title }}</h6>
<div mat-dialog-content class="subtitle-2 py-10!">
  <div>{{ data.alertMessage }}</div>
  @if (!data?.hideCannotBeUndone) {
    <div>This cannot be undone.</div>
  }
</div>
<mat-divider class="mx-20! -mb-10!" />
<mat-dialog-actions [ngClass]="{ biggerButtons: data.biggerButtons }">
  @if (!data?.hideCancel) {
    <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  }
  <button matButton="elevated" class="red-button" cdkFocusInitial [mat-dialog-close]="data.confirmButton">
    {{ data.confirmButton }}
  </button>
</mat-dialog-actions>
